import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, Subscription, filter } from "rxjs";
import { AppState } from "src/app/store/app.reducer";
import * as DeviceActions from 'src/app/store/device/device.actions';
import { selectFirmwareUpdate, selectCurrentDeviceStatus, selectfwUpdateStart } from "src/app/store/device/device.selector";
import { environment } from "src/environments/environment";
import { FirmwareUpdate, PostFirmwareUpdate } from "src/app/model/firmware-update";
import { DeviceStatus } from "src/app/model/device-status";
import { CLOUD_FW_UPGRADE_STATE } from "src/app/conf/firmware-upgrade";
import { StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";

@Component({
	templateUrl: './update-firmware.dialog.component.html',
})

export class UpdateFirmwareDialogComponent implements OnInit, OnDestroy {
	deviceStatus$: Observable<DeviceStatus | undefined>;
	deviceStatusSub: Subscription | undefined;
	firmwareUpdate$: Observable<FirmwareUpdate[] | undefined>;
	firmwareUpdateSub: Subscription | undefined;

	deviceStatus: DeviceStatus;
	mtmaFirmwareUpdates: FirmwareUpdate[] = [];

	fwUpdateStart = false;
	fwUpdateStart$: Observable<boolean | undefined>;
	fwUpdateStartSub: Subscription | undefined;

	// design
	screenWidth: number;

	constructor(
		private fb: FormBuilder,
		private store: Store<AppState>,
		private dialogRef: DynamicDialogRef,
		public config: DynamicDialogConfig
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		this.deviceStatus$ = this.store.select(selectCurrentDeviceStatus);
		this.firmwareUpdate$ = this.store.select(selectFirmwareUpdate);
		this.fwUpdateStart$ = this.store.select(selectfwUpdateStart);
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.onResize();
	}

	subscribeAll(): void {
		this.firmwareUpdateSub = this.firmwareUpdate$.subscribe(mtmaFirmwareUpdates => {
			this.mtmaFirmwareUpdates = mtmaFirmwareUpdates.filter(fir => fir.AvailableFWVersion);
		});
		this.deviceStatusSub = this.deviceStatus$.pipe(filter(d => !!d))
			.subscribe(currentDeviceStatus => {
				this.deviceStatus = currentDeviceStatus;
			});
		this.fwUpdateStartSub = this.fwUpdateStart$.subscribe(fwUpdateStart => {
			this.fwUpdateStart = fwUpdateStart;
		});
	}


	closeDialog(): void {
		this.dialogRef.close();
	}

	ngOnDestroy(): void {
		this.deviceStatusSub?.unsubscribe();
		this.firmwareUpdateSub?.unsubscribe();
		this.fwUpdateStartSub?.unsubscribe();
	}

	firmwareUpdate(device: string): void {
		let test = false;
		if (environment.apiUrl !== 'https://app.cameconnect.net/api') {
			test = true;
		}
		const firmware = new PostFirmwareUpdate();
		firmware.Component = device;
		this.store.dispatch(DeviceActions.postFirmwareUpdate({ firmware, test }));
		this.closeDialog();
	}

	offline(): boolean {
		return !this.deviceStatus.Online;
	}

	onFirmwareUpdate(): boolean {
		return this.deviceStatus.FwUpdate === CLOUD_FW_UPGRADE_STATE.CLOUD_FW_UPGRADE_STATE_STARTED ||
			this.deviceStatus.FwUpdate === CLOUD_FW_UPGRADE_STATE.CLOUD_FW_UPGRADE_STATE_UPDATING;
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}
}